import { apiEndpointBase } from "./endpoint.config";

const base = apiEndpointBase;

export default {
  submit: (communityId) => base + "community/" + communityId + "/referral/submit",
  stats: (communityId) => base + "community/" + communityId + "/referral/stats",
  submissions: (communityId, page = 1, limit = 10, search = "") =>
    base +
    "community/" +
    communityId +
    "/referral/submissions?page=" +
    page +
    "&limit=" +
    limit +
    (search ? "&search=" + encodeURIComponent(search) : ""),
};
